module.exports = __webpack_public_path__ + "static/mid2-22ae795f89f731712f219376282ea87a.png";